import { LocationOption } from "./JobFilterCollaborator";

export function getCitiesFromLocations(locations : LocationOption[]){
    return locations.filter(x => x.city != null && !x.showAllCompact);
}

export function getStatesFromLocations(locations : LocationOption[]){
    return locations.filter(x => x.city == null && !x.showAllCompact);
}